import React from 'react';
import { CmsFeature } from '../../types/contentstack';
import { Icon } from '@hills-design-system/components';

interface CmsHomePageCalloutsData {
  name?: string;
  component?: string;
  features: CmsFeature[];
}

interface CmsHomePageCalloutsProps {
  data: CmsHomePageCalloutsData;
}

export const CmsHomePageCallouts: React.FC<CmsHomePageCalloutsProps> = ({ data }) => {
  if (!data.features || data.features.length === 0) {
    return null;
  }

  return (
    <div className="w-full max-w-[862px] mx-auto">
      <div className="bg-white border border-[#E5E7EB] rounded-lg divide-y divide-[#E5E7EB]">
        {data.features.map((feature, index) => (
          <div key={feature._metadata?.uid ?? index} className="px-6 py-5 flex items-start gap-4">
            <div className="flex-shrink-0 mt-1">
              <Icon color="rgba(0, 84, 164, 1)" icon="Check" />
            </div>
            <div
              className="flex-1 text-[#192026] text-lg leading-relaxed [&>p]:m-0"
              dangerouslySetInnerHTML={{ __html: feature.body }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CmsHomePageCallouts;
